import { Component, Event, EventEmitter, h, Host, Prop, State } from "@stencil/core";
import { ButtonSize, ButtonVariant } from "../../button/button.enum";

@Component({
    tag: "ux-chat-message-bar",
    styleUrl: "chat-message-bar.scss",
    shadow: false
})
export class ChatMessageBar {
    /** The placeholder text. */
    @Prop() readonly placeholder!: string;
    /** indicates if the message bar is disabled */
    @Prop() readonly disabled?: boolean;
    /** Fired when the message has been sent */
    @Event() uxMessageSend: EventEmitter<string>;

    @State() messageText = "";

    private handleInput(event: Event) {
        this.messageText = (event.target as HTMLInputElement).value;
    }

    private handleKeydown(event: KeyboardEvent) {
        if (event.key === "Enter" && !event.shiftKey) {
            event.preventDefault();
            event.stopPropagation();
            this.sendMessage();
        }
    }

    private sendMessage() {
        if (!this.disabled && this.messageText.trim()) {
            this.uxMessageSend.emit(this.messageText);
            this.messageText = "";
        }
    }

    private autoGrowTextarea(event: Event) {
        const textarea = event.target as HTMLTextAreaElement;
        textarea.style.height = "auto";
        textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`;
    }

    render() {
        return (
            <Host>
                <div id="chat-message-bar">
                    <textarea
                        id="chat-textarea"
                        name="chat-message"
                        placeholder={this.placeholder}
                        disabled={this.disabled ? false : undefined}
                        value={this.messageText}
                        onInput={(event) => {
                            this.handleInput(event);
                            this.autoGrowTextarea(event);
                        }}
                        onKeyPress={(event) => this.handleKeydown(event)}
                        style={{ overflow: "hidden", resize: "none", maxHeight: "120px" }}
                    ></textarea>
                    <ux-button
                        size={ButtonSize.Icon}
                        variant={ButtonVariant.Primary}
                        icon="paper-plane"
                        label="Send"
                        disabled={this.disabled}
                        onClick={() => this.sendMessage()}
                    />
                </div>
            </Host>
        );
    }
}
